import type { EmptyResponse, WithdrawProjectRequest } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class CreateWithdrawForProjectUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(body: WithdrawProjectRequest): Promise<EmptyResponse> {
    if (!body || typeof body !== 'object') {
      throw new Error('body is required');
    }
    return this.repository.createWithdrawForProject(body);
  }
}


